module.exports = __webpack_public_path__ + "static/media/get-started-interests.69c39e11.png";